import React, { Component } from "react";
import Moment from "moment";
import {
  apiURL,
  change_date_format,
  get_changed_time,
  registerAPIURL,
  sanitizeHtml,
  teacherApiURL,
} from "../utils";
import Footer from "../include/Footer";
import Header from "../include/Header";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  CssBaseline,
  Grid,
  Container,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Snackbar,
  Switch,
  FormControl,
  InputAdornment,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import axios from "axios";
import CommonEditor from "../editor/CommonEditor";

// import 'tinymce/tinymce';
// import 'tinymce/icons/default';
// import 'tinymce/themes/silver';
// import 'tinymce/plugins/paste';
// import 'tinymce/plugins/link';
// import 'tinymce/plugins/image';
// import 'tinymce/plugins/table';
// import 'tinymce/skins/ui/oxide/skin.min.css';
// import 'tinymce/skins/ui/oxide/content.min.css';
// import 'tinymce/skins/content/default/content.min.css';
import { Editor } from "@tinymce/tinymce-react";

import DateFnsUtils from "@date-io/date-fns";
import SearchIcon from "@material-ui/icons/Search";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  DatePicker,
} from "@material-ui/pickers";
import Helmet from "react-helmet";
import Delete from "../delete/Delete";

import EditIcon from "@material-ui/icons/Edit";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import "../style/Style.css";
import ImageSearchIcon from "@material-ui/icons/ImageSearch";
import ClearIcon from "@material-ui/icons/Clear";
import Meta from "../meta/Meta";
import PushNotification from "../push-notification/PushNotification";
import XLSX from "xlsx";
import ExportExcelButton from "../utils/ExportExcelButton";

const drawerWidth = 280;
// const useStyles = makeStyles((theme) => ({

// }))

const useStyles = (theme) => ({
  buttonEdit: {
    textTransform: "capitalize",
    border: "1px solid #035eab",
    borderRadius: "0px",
    marginRight: "10px",
    padding: "2px 5px",
  },
  buttonAdd: {
    textTransform: "capitalize",
  },
  table: {
    minWidth: 650,
  },
});

class Article extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      // drawerOpen: false,
      drawerOpen: true,
      showDialog: false,
      qualification: "",
      file: null,
      imagePreview: null,
      articleData: [],
      page: 1,
      per: 20,
      total_pages: null,
      loading: false,
      imageEdit: false,
      showSnackbar: false,
      snackBarMessage: "",
      severityColor: "",
      mode: "",
      editorVlaue: "",
      selecteDate: new Date(),
      changeDate: "",
      articleCategory: [],
      category: "",
      noData: "",
      link: "",
      author: "",
      language: "",
      board: "",
      isSubmitDisabled: false,
      isSubmitting: false,
      originalArticleData: [],
      searchValue: "",
    };
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.articleAddDialog = this.articleAddDialog.bind(this);
    this.articleDialogClose = this.articleDialogClose.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onEditFormSubmit = this.onEditFormSubmit.bind(this);
    this.editDialogOpen = this.editDialogOpen.bind(this);
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
  }

  handleDrawerOpen(drawerState) {
    this.setState({
      drawerOpen: drawerState,
    });
  }

  changeHandler = (e, type) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    //console.log(e.target.name +'===='+e.target.value);
  };

  handleImageChange = (e) => {
    if (!e.target.files.length) return; // Prevent errors if no file is selected

    const file = e.target.files[0];
    const fileSizeMB = file.size / (1024 * 1024); // Convert bytes to MB

    if (fileSizeMB > 5) {
      this.setState({
        showSnackbar: true,
        snackBarMessage: "Image should not be more than 5MB",
        severityColor: "error",
        snackBarTimer: 3000,
      });
      return;
    }

    this.setState({
      imagePreview: URL.createObjectURL(file),
      file: file,
      imageEdit: true,
    });
  };

  // componentDidMount() {
  //   this._isMounted = true;
  //   this.articleListData();
  //   this.scrollListener = window.addEventListener("scroll", (e) => {
  //     this.handleScroll(e);
  //   });
  //   this.articleCategory();
  // }
  componentDidMount() {
  //initial api call to load artile list
  this._isMounted = true;
  // Load article categories dropdown data
  this.articleListData();
  // Added scroll event listener for pagination (load more on scroll)
  this.articleCategory();

  window.addEventListener("scroll", this.handleScroll);
}
  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("scroll", this.handleScroll);
  }

  articleCategory = () => {
    const headers = {
      "Content-type": "application/json",
    };
    axios
      .get(teacherApiURL("article/get_all_article_category"), {
        headers: headers,
      })
      .then((response) => {
        if (this._isMounted) {
          const resultData = response.data;
          if (resultData.status === true || resultData.status === 1) {
            this.setState({
              articleCategory: resultData.result,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  searchHandler = (e) => {
    // When the search changes, reset the page and search value
    this.setState({ page: 1, searchValue: e.target.value }, () => {
      // Fetch the data after setting the state
      this.articleListData();
    });
  };

  articleListData = (isLoadMore = false) => {
    this.setState({ loading: true, noData: "" });

    const { per, page, articleData, searchValue } = this.state;
    const headers = { "Content-type": "application/json" };

    // If not loading more, reset page and clear current articleData to fetch new results
    const updatedPage = isLoadMore ? page : 1;

    const body = {
      search: searchValue || "", // Use the search value directly
    };

    if (!isLoadMore) {
      // Clear existing data when performing a new search
      this.setState({ articleData: [] });
    }

    axios
      .post(
        teacherApiURL(
          `article/article_blog?per_page=${per}&page=${updatedPage}`,
        ),
        body,
        { headers },
      )
      .then((response) => {
        if (this._isMounted) {
          const resultData = response.data;

          if (resultData.status === true || resultData.status === 1) {
            if (resultData.result && resultData.result.length > 0) {
              // Update the state with new or appended data
              this.setState({
                articleData: isLoadMore
                  ? [...articleData, ...resultData.result] // Append data if load more
                  : resultData.result, // Replace data for new search results
                scrolling: false,
                total_pages: resultData.total_pages,
                page: updatedPage + 1, // Increment page for next load
              });
            } else {
              // Show message if no data found
              this.setState({ noData: "No Article Found" });
            }
          } else {
            // Handle unsuccessful API status
            this.setState({ noData: "No Article Found" });
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching articles:", error);
        this.setState({ noData: "Error fetching data, please try again" });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  // loadMore = () => {
  //   if (!this._isMounted) return;

  //   this.setState({ scrolling: true }, () => {
  //     this.articleListData(true);
  //   });
  // };
   loadMore=() =>{
     const { loading, page, total_pages } = this.state;

  if (loading) return; // Prevent duplicate API calls
  if (page > total_pages) return; // Stop after last page

  this.articleListData(true);
   }
  // handleScroll = () => {
  //   if (!this._isMounted) return;

  //   const table = document.querySelector("table"); // Ensure lowercase 'table'
  //   if (!table) return; // Exit if no table exists

  //   const lastRow = table.querySelector("tr:last-child"); // Get last row
  //   if (!lastRow) return;

  //   const lastRowOffset = lastRow.offsetTop + lastRow.clientHeight;
  //   const pageOffset = window.pageYOffset + window.innerHeight;

  //   if (pageOffset >= lastRowOffset) {
  //     this.loadMore(); // Call loadMore when scrolled to bottom
  //   }
  // };
  handleScroll = () => {
  // Stop execution if component is unmounted
  if (!this._isMounted) return;

  const { loading, page, total_pages } = this.state;

  if (loading) return; // Prevent API call while already loading
  if (page > total_pages) return; // Stop if all pages loaded

  const table = document.querySelector("table");
  if (!table) return;

  const lastRow = table.querySelector("tr:last-child");
  if (!lastRow) return;

  const lastRowOffset = lastRow.offsetTop + lastRow.clientHeight;
  const pageOffset = window.pageYOffset + window.innerHeight;
  
  // Trigger next page API call when user reaches near bottom of table
  if (pageOffset >= lastRowOffset - 100) {
    this.loadMore();
  }
};
  handleImageUpload = (blobInfo, success, failure, progress) => {
    const formData = new FormData();
    formData.append("image", blobInfo.blob(), blobInfo.filename());

    // Make an AJAX request to upload the image
    fetch(registerAPIURL("news/upload_image"), {
      method: "POST",
      body: formData,
      // Provide progress handling
      onUploadProgress: (event) => {
        const progressPercentage = Math.round(
          (event.loaded / event.total) * 100,
        );
        progress(progressPercentage);
      },
    })
      .then((response) => {
        // Check if the upload was successful
        if (!response.ok) {
          throw new Error("Image upload failed");
        }
        // Return the image URL
        return response.json();
      })
      .then((data) => {
        // Call the success handler with the image URL
        success(data.path);
      })
      .catch((error) => {
        // Call the failure handler with the error message
        failure(error.message);
      });
  };

  onFormSubmit = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return; // Prevent submission if already submitting

    this.setState({ isSubmitting: true });

    const formData = new FormData();
    formData.append("file", this.state.file);
    formData.append("title", this.state.title);
    formData.append("selectedDate", this.state.selecteDate);
    formData.append(
      "changedDate",
      change_date_format(this.state.selecteDate) +
        " " +
        get_changed_time(this.state.selecteDate, false),
    );
    formData.append("description", this.state.editorVlaue);
    formData.append("categoryId", this.state.category);
    formData.append("link", this.state.link);
    formData.append("authorName", this.state.author);
    formData.append("language", this.state.language);
    formData.append("board", this.state.board);
    const headers = {
      "content-type": "application/json",
      Accept: "application/json",
    };

    const endPoint =
      this.state.category == "6" ? "article/addBlog" : "article/add";

    axios
      .post(teacherApiURL(`${endPoint}`), formData, { headers: headers })
      .then((response) => {
        const resultData = response.data;
        if (resultData.status === true || resultData.status === 1) {
          this.articleDialogClose();
          window.location.reload();
          this.componentDidMount();
          this.setState({
            imageEdit: false,
            imagePreview: null,
            file: null,
            showSnackbar: true,
            snackBarMessage: resultData.message,
            severityColor: "success",
            snackBarTimer: 3000,
          });
        } else {
          this.setState({
            showSnackbar: true,
            snackBarMessage: resultData.message,
            severityColor: "error",
            snackBarTimer: 2000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          showSnackbar: true,
          snackBarMessage: "An error occurred",
          severityColor: "error",
          snackBarTimer: 2000,
        });
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  };

  onEditFormSubmit = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;

    this.setState({ isSubmitting: true });

    const editFormData = new FormData();
    editFormData.append("id", this.state.id);
    editFormData.append("title", this.state.title);
    editFormData.append("select_date", this.state.selecteDate);
    editFormData.append(
      "change_date",
      change_date_format(this.state.selecteDate) +
        " " +
        get_changed_time(this.state.selecteDate, false),
    );
    editFormData.append("description", this.state.editorVlaue);
    editFormData.append("link", this.state.link);
    editFormData.append("author_name", this.state.author);
    editFormData.append("language", this.state.language);
    editFormData.append("board", this.state.board);
    if (this.state.file !== null) {
      editFormData.append("file", this.state.file);
    }
    editFormData.append("exist_file", this.state.image);
    editFormData.append("image_change", this.state.imageEdit);
    editFormData.append("category", this.state.category);
    const headers = {
      "content-type": "application/json",
      Accept: "application/json",
    };
    const endPoint =
      this.state.category == "6" ? "article/editBlog" : "article/edit";
    editFormData.append(
      "directoryName",
      this.state.category == "6" ? "blog" : "article",
    );
    axios
      .post(teacherApiURL(`${endPoint}`), editFormData, { headers: headers })
      .then((response) => {
        const resultData = response.data;
        if (resultData.status === true || resultData.status === 1) {
          this.setState({
            imageEdit: false,
            imagePreview: null,
            file: null,
          });
          this.articleDialogClose();
          window.location.reload();
          this.componentDidMount();
          this.setState({
            showSnackbar: true,
            snackBarMessage: resultData.message,
            severityColor: "success",
            snackBarTimer: 3000,
          });
        } else {
          this.setState({
            showSnackbar: true,
            snackBarMessage: resultData.message,
            severityColor: "error",
            snackBarTimer: 2000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          showSnackbar: true,
          snackBarMessage: "An error occurred",
          severityColor: "error",
          snackBarTimer: 2000,
        });
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  };

  
  changeStatus = (id, status, category_id) => {
    // Convert current status to opposite value (if "1" then "0", if "0" then "1")
    const newStatus = status == 1 ? 0 : 1;
    const urlStr =
      category_id == "6"
        ? "article/blog/changeStatus/"
        : "article/change_status/";
    const headers = {
      "Content-type": "application/json",
    };
    axios
      .get(teacherApiURL(urlStr + id + "/" + newStatus), {
        headers: headers,
      })
      .then((response) => {
        const resultData = response.data;
        if (resultData.status === true || resultData.status === 1) {
          const updatedArticle = this.state.articleData.map((article) => {
            if (article.fldi_id === id) {
              const _article = { ...article };
              _article.flg_status = newStatus;
              return _article;
            }
            return article;
          });
          this.setState({ articleData: updatedArticle });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  articleAddDialog = (e) => {
    this.setState({
      showDialog: true,
      mode: "add",
      file: "",
      title: "",
      selecteDate: new Date(),
      editorVlaue: "",
      link: "",
      author: "",
      language: "",
      image: "",
      category: "",
      board: "",
      isSubmitDisabled: false, // Reset the button state when opening the dialog
    });
  };

  editDialogOpen = (e) => {
    this.setState({
      showDialog: true,
      mode: "edit",
      id: e.fldi_id,
      image: e.fldv_image_url,
      title: e.fldv_title,
      selecteDate: e.fldv_selected_date,
      editorVlaue: e.fldt_description,
      link: e.fldv_link,
      author: e.fldv_author_name,
      language: e.fldv_language,
      category: e.fldi_category_id,
      board: e.fldv_boards,
      isSubmitDisabled: false, // Reset the button state when opening the dialog
    });
  };

  articleDialogClose = () => {
    this.setState({
      showDialog: false,
      mode: "",
      file: "",
      title: "",
      selecteDate: new Date(),
      editorVlaue: "",
      link: "",
      author: "",
      language: "",
      image: "",
      category: "",
      board: "",
      imagePreview: null,
      imageEdit: false,
      // Reset search when dialog closes
      searchValue: "",
      articleData:
        this.state.originalArticleData.length > 0
          ? [...this.state.originalArticleData]
          : this.state.articleData,
    });
  };

  snackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ showSnackbar: false });
  };

  handleEditorChange = (content, editor) => {
    this.setState({
      editorVlaue: content,
    });
  };

  handleDateChange = (date) => {
    this.setState({
      selecteDate: new Date(date),
      changeDate: change_date_format(date),
    });
  };

  successDelete = (e, id, index) => {
    if (e === true) {
      const deleteArticle = this.state.articleData;
      deleteArticle.splice(index, 1);
      this.setState({
        articleData: deleteArticle,
        showSnackbar: true,
        snackBarMessage: "data deleted suceesfully",
        severityColor: "success",
        snackBarTimer: 3000,
      });
    }
  };

  exportFile() {
    let headers = [
      [
        "Title",
        "Category",
        "Writer",
        "Image",
        "Created Date",
        "Status",
        "Delete",
      ],
    ]; //added writer
    this.state.articleData.forEach((value) => {
      let valueArray = [
        value.fldv_title,
        value.fldv_category,
        value.fldv_author_name, //added author/writer name
        value.fldv_image_url,
        Moment(value.flddt_created_date).format("D MMMM, YYYY"),
        value.flg_status == 1 ? "Active" : "Deactive",
        value.flg_is_deleted == "1" ? "Not Delete" : "Deleted",
      ];
      headers.push(valueArray);
    });

    const wb = XLSX.utils.book_new();
    const wsAll = XLSX.utils.aoa_to_sheet(headers);

    XLSX.utils.book_append_sheet(wb, wsAll, "Article");
    XLSX.writeFile(wb, "export-article.xlsx");
  }

  removeImage = (e) => {
    this.setState({
      imagePreview: "",
      file: "",
      imageEdit: false,
      image: "",
    });
  };

  render() {
    const { classes } = this.props;
    const loadingCSS = {
      height: "30px",
      margin: "10px",
    };
    const loadingTextCSS = { display: this.state.loading ? "block" : "none" };
    return (
      <div>
        <Helmet>
          <title>Article</title>
        </Helmet>
        <Header forwardDrawerOpen={this.handleDrawerOpen.bind(this)} />
        <CssBaseline />
        <div
          style={{
            paddingTop: "5rem",
            paddingLeft: this.state.drawerOpen ? drawerWidth + 15 : 72 + 15,
            transition: "padding 0.5s ease",
          }}
        >
          <main>
            <Container maxWidth="lg">
              <Box bgcolor="background.paper" mt={2} boxShadow={3}>
                <Alert
                  action={
                    <div>
                      <TextField
                        className="textField"
                        type="text"
                        placeholder="...Search"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          style: {
                            color: "#414141",
                            backgroundColor: "rgba(255, 255, 255, 0.29)",
                          },
                        }}
                        size="small"
                        id="search"
                        variant="outlined"
                        style={{ fontColor: "#fff", marginRight: "1rem" }}
                        name="search"
                        onChange={(e) => this.searchHandler(e)}
                      />
                      <Button
                        className={classes.buttonAdd}
                        variant="contained"
                        color="primary"
                        startIcon={<AddCircleOutlineOutlinedIcon />}
                        onClick={this.articleAddDialog}
                      >
                        {" "}
                        Add Article{" "}
                      </Button>
                      <ExportExcelButton
                        clickProp={(e) => this.exportFile(e)}
                      />
                    </div>
                  }
                  variant="outlined"
                  severity="default"
                  boxShadow={3}
                >
                  <h2>Article</h2>
                </Alert>
              </Box>
              <Grid container spacing={3} align="center">
                <Grid item xs={12}>
                  <Box
                    bgcolor="background.paper"
                    boxShadow={3}
                    px={2}
                    py={2}
                    mt={1}
                  >
                    <TableContainer
                      mt={1}
                      component={Paper}
                      className="customTable"
                    >
                      <Table
                        size="small"
                        stickyHeader
                        aria-label="sticky table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell> Title </TableCell>
                            <TableCell>Auther Name</TableCell>
                            <TableCell> Date & Time </TableCell>
                            <TableCell> Category </TableCell>
                            {/*<TableCell>Description</TableCell>
                                                <TableCell>Image</TableCell>*/}
                            <TableCell>No of Views</TableCell>
                            <TableCell>No of Bookmarks</TableCell>
                            <TableCell>Average Rating</TableCell>
                            <TableCell>No of Shares</TableCell>
                            <TableCell>No of Comments</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.articleData.map((arrList, index) => {
                            return (
                              <TableRow key={arrList.fldi_id}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{arrList.fldv_title}</TableCell>
                                <TableCell>{arrList.fldv_author_name}</TableCell>
                                <TableCell>
                                  {arrList.fldv_changed_date}
                                </TableCell>
                                <TableCell>{arrList.fldv_category}</TableCell>
                                <TableCell>{arrList.no_of_views}</TableCell>
                                <TableCell>{arrList.no_of_bookmark}</TableCell>
                                <TableCell>{arrList.average_rating}</TableCell>
                                <TableCell>{arrList.no_of_share}</TableCell>
                                <TableCell>{arrList.no_of_comments}</TableCell>

                                {/*<TableCell>{sanitizeHtml(arrList.fldt_description)}</TableCell>
                                                    <TableCell><img style={{width:"25px"}} src={arrList.fldv_image_url} alt={arrList.fldv_title} /></TableCell>*/}
                                <TableCell>
                                  {" "}
                                  <Switch
                                    size="small"
                                    checked={arrList.flg_status == 1}
                                    color="primary"
                                    onChange={() =>
                                      this.changeStatus(
                                        arrList.fldi_id,
                                        arrList.flg_status,
                                        arrList.fldi_category_id,
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell>
                                  <Button
                                    className={classes.buttonEdit}
                                    variant="outlined"
                                    color="default"
                                    onClick={() => this.editDialogOpen(arrList)}
                                    startIcon={
                                      <EditIcon
                                        style={{
                                          color: "#035eab",
                                          fontSize: "1rem",
                                        }}
                                      />
                                    }
                                  >
                                    Edit
                                  </Button>
                                  <Delete
                                    deleteID={arrList.fldi_id}
                                    table={
                                      arrList.fldi_category_id == 6
                                        ? "blog"
                                        : "article"
                                    }
                                    onSuccessDelete={(e) =>
                                      this.successDelete(
                                        e,
                                        arrList.fldi_id,
                                        index,
                                      )
                                    }
                                  />
                                  {/* <Meta
                                    primaryId={arrList.fldi_id}
                                    useFor={"inner_page"}
                                    table={"article"}
                                    onSuccessDelete={(e) =>
                                      this.successDelete(
                                        e,
                                        arrList.fldi_id,
                                        index
                                      )
                                    }
                                  /> */}

                                  {/* <PushNotification
                                    id={arrList.fldi_id}
                                    body={arrList.fldt_description}
                                    title={arrList.fldv_title}
                                    url={"article"}
                                  /> */}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>

                  <div
                    ref={(loadingRef) => (this.loadingRef = loadingRef)}
                    style={loadingCSS}
                  >
                    <span style={loadingTextCSS}>Loading...</span>
                    <span>
                      {this.state.noData && this.state.articleData.length === 0
                        ? this.state.noData
                        : ""}
                    </span>
                  </div>
                </Grid>
              </Grid>
              <Footer />
            </Container>
          </main>
        </div>

        <Dialog
          open={this.state.showDialog}
          fullWidth={true}
          maxWidth={"md"}
          disableEnforceFocus
        >
          <form
            id="courses"
            onSubmit={
              this.state.mode === "edit"
                ? (e) => this.onEditFormSubmit(e)
                : (e) => this.onFormSubmit(e)
            }
          >
            <DialogTitle id="form-dialog-title">
              <h3 style={{ textAlign: "center" }}>
                {this.state.mode === "add" ? "Add" : "Edit"} Article{" "}
              </h3>
            </DialogTitle>
            <DialogContent style={{ overflowY: "hidden" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{ width: "100%" }}
                    required
                  >
                    <InputLabel>Category</InputLabel>
                    <Select
                      name="category"
                      value={this.state.category}
                      onChange={(e) => this.changeHandler(e)}
                      label="Speaker"
                      required
                    >
                      <MenuItem value="">
                        {" "}
                        <em>None</em>{" "}
                      </MenuItem>
                      {this.state.articleCategory.map((arrCategory, index) => {
                        return (
                          <MenuItem key={arrCategory.id} value={arrCategory.id}>
                            {arrCategory.category}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Title"
                    variant="outlined"
                    name="title"
                    size="small"
                    onChange={(e) => this.changeHandler(e)}
                    value={this.state.title}
                    // required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl size="small" style={{ width: "100%" }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        inputVariant="outlined"
                        label="Choose Date"
                        value={this.state.selecteDate}
                        onChange={(date) => this.handleDateChange(date)}
                        name="date"
                        format="dd/MM/yyyy"
                        showTodayButton
                        minDate={new Date(this.state.selecteDate)}
                        size="small"
                        // required
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Author"
                    variant="outlined"
                    name="author"
                    size="small"
                    onChange={(e) => this.changeHandler(e)}
                    value={this.state.author}
                    // required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{ width: "100%" }}
                    // required
                  >
                    <InputLabel>Language</InputLabel>
                    <Select
                      name="language"
                      value={this.state.language}
                      onChange={(e) => this.changeHandler(e)}
                      label="Language"
                      // required
                    >
                      <MenuItem value="English">English</MenuItem>
                      <MenuItem value="Marathi">Marathi</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Link"
                    variant="outlined"
                    name="link"
                    size="small"
                    onChange={(e) => this.changeHandler(e)}
                    value={this.state.link}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{ width: "100%" }}
                    // required
                  >
                    <InputLabel>News Type</InputLabel>
                    <Select
                      name="board"
                      value={this.state.board}
                      onChange={(e) => this.changeHandler(e)}
                      label="News Type"
                      // required
                    >
                      <MenuItem value="National">National</MenuItem>
                      <MenuItem value="Maharashtra">Maharashtra</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <CommonEditor
                    key="article-editor"
                    initialValue={this.state.editorVlaue}
                    onChange={(content) =>
                      this.setState({ editorVlaue: content })
                    }
                    height={188}
                    enableTableWrap={true}
                    images_upload_handler={this.handleImageUpload}
                    convert_urls={false}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  {this.state.imagePreview || this.state.image ? (
                    <ClearIcon onClick={(e) => this.removeImage(e)} />
                  ) : (
                    ""
                  )}
                  {this.state.imageEdit === true ? (
                    <img
                      style={{
                        width: "40px",
                        display: "flex",
                        marginBottom: "1rem",
                        marginLeft: "10%",
                      }}
                      src={this.state.imagePreview}
                    />
                  ) : (
                    <img
                      style={{
                        width: "40px",
                        display: "flex",
                        marginBottom: "1rem",
                        marginLeft: "10%",
                      }}
                      src={this.state.image}
                    />
                  )}
                  <Button
                    variant="contained"
                    startIcon={<ImageSearchIcon />}
                    color="primary"
                    component="label"
                  >
                    Select Main Image
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={this.handleImageChange}
                      accept="image/*"
                    />
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className="buttonCancel">
              <Button
                variant="contained"
                onClick={() => this.articleDialogClose()}
                color="secondary"
              >
                {" "}
                Cancel{" "}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={this.state.isSubmitDisabled}
              >
                {" "}
                Submit{" "}
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        <Snackbar
          open={this.state.showSnackbar === true}
          autoHideDuration={this.state.snackBarTimer}
          onClose={this.snackBarClose}
        >
          <Alert
            onClose={this.snackBarClose}
            severity={this.state.severityColor}
            elevation={6}
            variant="filled"
          >
            {this.state.snackBarMessage}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

export default withStyles(useStyles)(Article);
